<template>
  <v-layout class="align-center layout 2app--page-header">
    <div class="page-header-left">
      <h3 class="pr-3">{{title}}</h3>
    </div>
    <v-icon>{{icon}}</v-icon>
    <v-breadcrumbs :divider="divider" :items="breadcrumbs"></v-breadcrumbs>
    <v-spacer></v-spacer>
    <div v-if="refresh" class="page-header-right">
      <v-btn icon v-on:click="$emit('refresh')">
        <v-icon class="text--secondary">mdi-refresh</v-icon>
      </v-btn>
    </div>
  </v-layout>
</template>

<script>
export default {
  props: {
    title: String,
    icon: String,
    divider: String,
    breadcrumbs: Array,
    refresh: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="sass" scoped>
.disabled
  color: grey
  pointer-events: none
  text-decoration: blink

</style>
